<template>
  <md-dialog
    :id="refName"
    :ref="refName"
    :md-esc-to-close="false"
    :md-click-outside-to-close="false"
    :class="size"
    class="confirmation standard-modal"
  >
    <md-dialog-title>
      <div class="confirmation__title-wrapper">
        <img
          src="/static/images/success-green.svg"
          alt="icone-sucesso"
        >
        <div class="confirmation__title">
          {{ title }}
        </div>
      </div>
    </md-dialog-title>

    <md-dialog-content>
      <div class="standard-modal__description">
        <slot />

        <div class="confirmation__btn-wrapper">
          <button
            class="confirmation__btn"
            @click="firstButtonAction()"
          >
            {{ firstButtonText ? firstButtonText : 'OK' }}
          </button>
        </div>
      </div>
    </md-dialog-content>
  </md-dialog>
</template>

<script>
import mixin from './../modalMixin'

export default {
  name: 'ModalConfirmation',
  mixins: [mixin]
}
</script>

<style lang="scss">
.confirmation {
  &__btn-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 20px;
  }
  &__btn {
    background-color: #7f1a54;
    min-width: 160px;
    padding: 13px 20px;
    color: #fff;
    font-weight: 600;
    font-size: 14px;
    -ms-flex-align: center;
    align-items: center;
    text-transform: uppercase;
    height: auto;
    line-height: 1;
  }
  &__title {
    margin-top: 20px;
    font-weight: bold;
    font-size: 19.2px;
    text-align: center;
    color: #5A5A5A;
    width: 100%;
  }
  &__title-wrapper {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: center;
  }
}
</style>
